// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o1-1";
export var stateContainer = "_o1-0";